module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm-2 20c0 1.106-.894 2-2 2s-2-.894-2-2v-8c0-1.106.894-2 2-2s2 .894 2 2v8zm8 0c0 1.106-.894 2-2 2s-2-.894-2-2v-8c0-1.106.894-2 2-2s2 .894 2 2v8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pause-4.js
// module id = 1338
// module chunks = 14